// export const OrderStatusEnum = {
//   1: { label: "Pending", class: "bg-secondary" },
//   2: { label: "InventoryReserved", class: "bg-primary" },
//   3: { label: "AwaitingPayment", class: "bg-warning text-dark" },
//   4: { label: "AwaitingConfirmation", class: "bg-warning text-dark" },
//   5: { label: "Paid", class: "bg-success" },
//   6: { label: "Processing", class: "bg-info text-dark" },
//   7: { label: "Shipped", class: "bg-primary" },
//   8: { label: "Delivered", class: "bg-success" },
//   9: { label: "Cancelled", class: "bg-danger" },
//   10: { label: "PaymentFailed", class: "bg-danger" },
// };

export const statusText = (status) => {
  switch (status) {
    case 1:
      return "Pending";
    case 2:
      return "InventoryReserved";
    case 3:
      return "AwaitingPayment";
    case 4:
      return "AwaitingConfirmation";
    case 5:
      return "Paid";
    case 6:
      return "Processing";
    case 7:
      return "Shipped";
    case 8:
      return "Delivered";
    case 9:
      return "Cancelled";
    case 10:
      return "PaymentFailed";
    default:
      return "Unknown";
  }
};

export const prescriptionStatus = (status) => {
  switch (status) {
    case 0:
      return "PendingReview";
    case 1:
      return "Approved";
    case 2:
      return "Substituted";
    case 3:
      return "Unavailable";
    default:
      return "Unknown";
  }
};
